import moment from 'moment-timezone'

export const formatDate = {
  methods: {
    formatDate: function (value) {
      if (!value) return ''
      return moment(value).format('D MMM YY')
    },
    formatDateToISOShort: function (value) {
      if (!value) return ''
      return moment(value).format('YYYY-MM-DD')
    },
    formatDateToISO: function (value) {
      if (!value) return ''
      return moment(value).toISOString()
    },
    formatDateHuman: function (value) {
      if (!value) return ''
      return moment(value).format('Do MMMM YYYY')
    },
    formatUnix: function (value) {
      if (!value) return ''
      return moment.unix(value).format('D MMM YY')
    },
    formatDateFromNow: function (value) {
      if (!value) return ''
      return moment(value).fromNow()
    },
    formatDateToDateAndMins: function (value) {
      if (!value) return ''
      return moment(value).format('D MMM YY HH:mm')
    },
    formatDateDifferenceInDays: function (value) {
      if (!value) return ''
      return moment(value).diff(moment(), 'days')
    }
  }
}
